import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ITicketHead } from "../../interfaces";
import Axios from "axios";
import config from "../../config";
import CoreComponent from "../CoreComponent";
import TicketModal from "../../components/TicketModal";

interface IState {
    models: ITicketHead[];
    isLoading: boolean;
    ids: number[];
    sort: string;
    type: string;
    isOpen: boolean;
    filter: string;
}

class Tickets extends CoreComponent<any, IState> {
    state: IState = {
        models: [],
        isLoading: true,
        ids: [],
        sort: "",
        type: "",
        isOpen: false,
        filter: "all",
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentWillMount() {
        this.loadModels();
    }

    async loadModels() {
        let url = null;

        url = `${config.api}/ticket?filter=${this.state.filter}`;

        if (this.state.sort) {
            url += `&sort=${this.state.sort}`;
        }

        if (this.state.type) {
            url += `&type=${this.state.type}`;
        }
        let res = await Axios.get(url);

        if (!this.isUnmounted) {
            this.setState({
                models: res.data.models,
                isLoading: false,
            });
        }
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? "asc"
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
                isLoading: true,
            },
            () => {
                this.loadModels();
            }
        );
    }

    handleModal() {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                this.loadModels();
            }
        );
    }

    changeFilter(filter: string) {
        this.setState(
            {
                filter,
                isLoading: true,
                models: [],
            },
            () => {
                this.loadModels();
            }
        );
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders quastions">
                <TicketModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                    isUser={true}
                />

                <h1 className={"riz-mobi__title title-index " + (!this.state.isLoading && this.state.models.length == 0 ? "" : "mb-0")}>Вопросы</h1>

                <div className="wrapper">
                    {!this.state.isLoading &&
                        this.state.models.length == 0 && (
                            <p className="riz-mobi__quastions-txt">У вас еще нет тикетов</p>
                        )}
                    {!this.state.isLoading &&
                        this.state.models.length > 0 && (<div className="riz-mobi__balance">
                            <div className="">
                                <div className="riz-mobi__balance-cover">


                                    <table className="riz-mobi__table riz-mobi__table-tickets w-100">
                                        <thead>
                                            <tr>
                                                <th>Номер</th>
                                                <th>Категория</th>
                                                <th>Тема</th>
                                                <th> Статус </th>
                                                <th> Действие </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.isLoading && (
                                                <tr>
                                                    <td colSpan={8}>
                                                        {t("Загрузка данных")}
                                                    </td>
                                                </tr>
                                            )}
                                            {this.state.models.map(
                                                (model: ITicketHead, i: number) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>#{model.id}</td>
                                                            <td>{model.department}</td>
                                                            <td>{model.topic}</td>
                                                            <td
                                                                className={
                                                                    model.statusName ==
                                                                        "Открыт"
                                                                        ? "text-success"
                                                                        : model.statusName ==
                                                                            "Закрыт"
                                                                            ? "text-danger"
                                                                            : "text-warning"
                                                                }
                                                            >
                                                                {model.statusName}
                                                            </td>
                                                            <td>
                                                                <NavLink
                                                                    to={
                                                                        "/user/ticket/" +
                                                                        model.id
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            "inline-block",
                                                                        padding:
                                                                            "5px 8px",
                                                                        background:
                                                                            "#ef225d",
                                                                        margin:
                                                                            "0 auto",
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    Посмотреть
                                                        </NavLink>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>)}
                    <a role="button" onClick={() => this.handleModal()} className={"riz-mobi__btn-quastions " + (!this.state.isLoading && this.state.models.length == 0 ? "" : "mt-5")}>Открыть тикет</a>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
    };
})(withTranslation()(Tickets));
